module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-ko-KR.d3ab8274.jpg";